import React from 'react';

const Blog = () => (
    <div>
        <h2>Blog Page</h2>
    </div>
);

export default Blog;
